module.exports = __webpack_public_path__ + "img/03.6a5df8f3.jpg";